import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=1dc7b11c&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports